import {
  createGroup,
  fetchGroups,
  addMember,
  updateGroup,
  deleteGroup,
  fetchGroupsBulk,
} from "@/api/groupService";

export default {
  //Create group
  async createGroup({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.createGroupBtn.load = true;
      rootState.loading.createGroupBtn.disabled = true;
      await createGroup(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Group created!",
          color: "success",
        },
        { root: true }
      );
      dispatch("fetchGroups", 1);
      rootState.loading.createGroupBtn.load = false;
      rootState.loading.createGroupBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.createGroupBtn.load = false;
      rootState.loading.createGroupBtn.disabled = false;
    }
  },

  //Update group
  async updateGroup({ commit, rootState, dispatch, state }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.updateGroupBtn.load = true;
      rootState.loading.updateGroupBtn.disabled = true;
      await updateGroup(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Group updated!",
          color: "success",
        },
        { root: true }
      );
      const pageNumber = state.groups.currentPage;
      dispatch("fetchGroups", pageNumber);
      rootState.loading.updateGroupBtn.load = false;
      rootState.loading.updateGroupBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.updateGroupBtn.load = false;
      rootState.loading.updateGroupBtn.disabled = false;
    }
  },

  //Fetch groups
  async fetchGroups({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchGroups(pageNumber);
      const groups = response.data.data;
      commit("SET_GROUP_DATA", groups);
      commit("SET_GROUP_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your groups arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Delete group
  async deleteGroup(context, payload) {
    context.commit("SHOW_PROGRESSBAR", true, { root: true });
    await deleteGroup(payload);
    const pageNumber = context.state.groups.currentPage;
    context.dispatch("fetchGroups", pageNumber);
    context.commit("HIDE_PROGRESSBAR", false, { root: true });
    context.commit(
      "SHOW_SNACKBAR",
      {
        text: "Contact deleted!",
        color: "success",
      },
      { root: true }
    );
  },

  //Add group member
  async addMember({ commit, rootState, dispatch, state }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.addMemberBtn.load = true;
      rootState.loading.addMemberBtn.disabled = true;
      await addMember(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Member added!",
          color: "success",
        },
        { root: true }
      );
      const pageNumber = state.groups.currentPage;
      dispatch("fetchGroups", pageNumber);
      rootState.loading.addMemberBtn.load = false;
      rootState.loading.addMemberBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.addMemberBtn.load = false;
      rootState.loading.addMemberBtn.disabled = false;
    }
  },

  //Fetch groups bulk
  async fetchGroupsBulk({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchGroupsBulk(pageNumber);
      const groups = response.data.data;
      commit("SET_GROUP_DATA", groups);
      commit("SET_GROUP_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your groups arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },
};
